// Settings the web app reads from its API at start instead of baking them in at build time (the same build runs on
// http://localhost:3200 and https://compta.rimon.lu): the RimoID address, in the desktop app too (INST 04.11.2026: its
// server decides, it may be another one than the build's). Mock mode keeps its build value.
import { API_URL, clientHeaders, MOCK } from '../api/client';
import { setRimoidUrl } from '../desktop/rimoid';

/** Vertrag U: the journal goes to RimoID's Protokoll – „Journal“ then opens RimoID's page instead of our own. */
export let PROTOCOL_IN_RIMOID = false;

export async function loadRuntimeConfig(): Promise<void> {
  if (MOCK) return;
  try {
    const res = await fetch(API_URL + '/config', { headers: clientHeaders(), signal: AbortSignal.timeout(3000) });
    if (!res.ok) return;
    const c = (await res.json()) as { rimoidUrl?: string; protocol?: boolean };
    PROTOCOL_IN_RIMOID = !!c.protocol;
    if (c.rimoidUrl) setRimoidUrl(c.rimoidUrl);
  } catch { /* API not reachable yet: the build value stays, the sign-in screen reports the API itself */ }
}
